import { FaUser, FaCog } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import { IoLogOutOutline } from "react-icons/io5";
import { useNavbarContext } from "../../../lib/context/NavBar/navbarContext";
import { RxHamburgerMenu } from "react-icons/rx";
import Cookies from "js-cookie";
import { useQueryClient } from "@tanstack/react-query";
import { useState, useEffect } from "react";

const Header = () => {
  const { isNavbarOpen, toggleNavbar } = useNavbarContext();
  const queryClient = useQueryClient();
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [nextButtonEnabled, setNextButtonEnabled] = useState(false);

  // Load the cookie value on component mount
  useEffect(() => {
    const cookieValue = Cookies.get("NextButton") || localStorage.getItem("NextButton");;
    setNextButtonEnabled(cookieValue === "true");
  }, []);

  const handleLogout = () => {
    const allCookies = Cookies.get();
    Object.keys(allCookies).forEach((cookieName) => {
      Cookies.remove(cookieName, {
        path: "/",
        domain: window.location.hostname,
      });
    });
    Cookies.remove("userToken");
   localStorage.removeItem("CurrentCounter");
    sessionStorage.clear();
    queryClient.clear();
    window.location.href = "/";
  };

  const handleNextButtonToggle = () => {
    const newValue = !nextButtonEnabled;
    setNextButtonEnabled(newValue);
    Cookies.set("NextButton", newValue.toString(), { path: "/" });
    localStorage.setItem("NextButton", newValue.toString());
  };

  return (
    <div className="bg-[#3C73F6] w-full py-3 relative">
      <div
        className={`${
          isNavbarOpen ? "justify-end" : "justify-between"
        } max-w-[1166px] m-auto flex items-center px-4 lg:px-0`}
      >
        {isNavbarOpen ? (
          ""
        ) : (
          <div className="text-white">
            <RxHamburgerMenu onClick={(e) => toggleNavbar()} />
          </div>
        )}

        <div className="flex items-center gap-4">
          {/* Settings Icon */}
          <div className="relative">
            <button
              onClick={() => setIsSettingsOpen(!isSettingsOpen)}
              className="w-10 h-10 rounded-full bg-white flex justify-center items-center hover:bg-gray-100 transition-colors duration-200"
            >
              <FaCog
                color={"#3C73F6"}
                className={`transform transition-transform duration-300 ${isSettingsOpen ? "rotate-90" : ""}`}
                size={20}
              />
            </button>

            {/* Settings Popup */}
            {isSettingsOpen && (
              <>
                {/* Backdrop */}
                <div
                  className="fixed inset-0 z-40"
                  onClick={() => setIsSettingsOpen(false)}
                />

                {/* Popup */}
                <div className="absolute right-0 mt-2 w-80 bg-white rounded-lg shadow-xl border border-gray-200 z-50 animate-fadeIn">
                  <div className="p-4">
                    <h3 className="text-lg font-semibold text-gray-800 mb-3 flex items-center">
                      <FaCog className="mr-2 text-black-600" size={16} />
                      Settings
                    </h3>

                    <div className="space-y-8">
                     
                      <div className="flex items-center justify-between">
                        <span className="text-xs text-black-500 border-t pt-2 mt-2">
                           Block Token Closing From this system
                        </span>
                        <button
                          onClick={handleNextButtonToggle}
                          className={`
                            relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none
                            ${nextButtonEnabled ? "bg-blue-600" : "bg-gray-300"}
                          `}
                        >
                          <span
                            className={`
                              inline-block h-4 w-4 transform rounded-full bg-white transition-transform
                              ${nextButtonEnabled ? "translate-x-6" : "translate-x-1"}
                            `}
                          />
                        </button>
                      </div>

                      
                     
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          {/* User Profile Dropdown */}
          <div className="flex group select-none cursor-pointer relative">
            <div className="w-10 h-10 rounded-full bg-white flex justify-center items-center -mr-9 border-2 border-[#3C73F6] z-10">
              <FaUser color={"#3C73F6"} />
            </div>
            <div className="rounded-full h-[2.3rem] mt-[1px] w-full bg-white text-base pl-10 pr-5 flex gap-2 items-center text-[#3C73F6] justify-around">
              {Cookies.get("userName")}
              <IoIosArrowDown
                className="group-hover:rotate-180 transition-all duration-300"
                color={"#3C73F6"}
              />
            </div>
            <div
              onClick={handleLogout}
              className="group-hover:flex hidden h-[2.3rem] bg-white rounded-full border border-[#3C73F6] absolute top-10 z-10 left-0 right-0 text-[#3C73F6] px-5 items-center justify-around"
            >
              <div className="size-10 absolute -top-[1.2] -left-1 rounded-full bg-white flex justify-center items-center border-[1px] border-[#3C73F6] z-10">
                <IoLogOutOutline size={"20px"} color={"#3C73F6"} />
              </div>
              <span className="pl-5">Logout</span>
            </div>
          </div>
        </div>
      </div>

      {/* Add animation styles */}
      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fadeIn {
          animation: fadeIn 0.2s ease-out;
        }
      `}</style>
    </div>
  );
};

export default Header;
